export const SET_DATA_SOURCE = 'app/Datasource/SET_DATA_SOURCE';
export const SET_WORKPLACE_TYPES = 'app/Datasource/SET_WORKPLACE_TYPES';
export const SET_FOOD_SERVICE = 'app/Datasource/SET_FOOD_SERVICE';
export const SET_BENEFITS = 'app/Datasource/SET_BENEFITS';
export const SET_PARKING_OPTIONS = 'app/Datasource/SET_PARKING_OPTIONS';
export const SET_WORKTRIP_TYPES = 'app/Datasource/SET_WORKTRIP_TYPES';
